import { css } from '@emotion/react';

export const childCss =
  ({ editable, hidden, patched, selectable, selected, wrapperIsSelectable, wrapperIsSelected }) =>
  (theme) =>
    [
      css`
        box-sizing: border-box;
        color: inherit;
        min-height: 32px;
        min-width: 120px;
        padding: 16px;
        position: relative;
        .wrapper {
          height: inherit;
        }
        label.elementLabel {
          color: inherit;
          display: block;
          font-weight: 600;
        }
      `,
      !editable &&
        css`
          padding: 8px 16px;
        `,
      hidden &&
        css`
          > * {
            opacity: 0.2;
          }
        `,
      patched &&
        css`
          outline-color: rgba(255, 255, 255, 0.1) !important;
        `,
      selectable &&
        css`
          outline: 1px dotted rgba(255, 255, 255, 0.3);
          &:hover {
            outline: 1px dotted ${theme.color.white};
          }
        `,
      selected &&
        css`
          outline: 1px solid ${theme.color.white} !important;
        `,
      wrapperIsSelectable &&
        css`
          .wrapper {
            outline: 1px dotted rgba(255, 255, 255, 0.3);
            &:hover {
              outline: 1px dotted ${theme.color.white};
            }
          }
        `,
      wrapperIsSelected &&
        css`
          .wrapper {
            outline: 1px solid ${theme.color.white} !important;
          }
        `,
    ];
